import React, { useEffect } from 'react';
import { Button, Grid } from "@chakra-ui/react";
import { Box, Flex, Text } from "@chakra-ui/layout";
import { Iconly } from "react-iconly";
import { useSelector } from 'react-redux';
import { getStudentRegisteredCourses } from '../../../action/studentAction';
import { useStudentAuthDispatch, StateType } from '../../../store/store';

function StudentCourses() {
  const dispatch = useStudentAuthDispatch();
  const { data: { token }, registeredCourses: {registered_courses} } = useSelector((state: StateType) => state.rootReducer.studentReducer);
  const studentToken = token.includes("Bearer") ? token.slice(17, (token.length - 2)) : token.slice(10, (token.length - 2));
  console.log(registered_courses)

  useEffect(() => {
    dispatch(getStudentRegisteredCourses(studentToken));
  }, []);


  return (
    <Flex flexDirection={"column"} boxShadow="2xl" m={7} p={5} borderRadius={"20px"}>
      <Text textTransform={"capitalize"} fontWeight={"extrabold"} fontSize={"xl"}>your registered courses</Text>
      <Grid gridTemplateColumns={"repeat(auto-fit, minmax(200px, 250px))"} justifyContent={"center"} mt={4} gap={2}>
        {registered_courses.length < 1 ? (
          <Text>No registered courses</Text>
        ) : registered_courses.map((courses, index) => (
          <Flex key={index} flexDirection={"column"} bgColor={"brand.grey"} p={4} borderRadius={"20px"} boxShadow="2xl" justifyContent="space-between">
            <Text fontSize={"lg"} fontWeight={"semibold"} textTransform={"capitalize"}>{courses.course_name}</Text>
            <Text noOfLines={3} fontSize={"xs"}>
              {courses.course_description}
            </Text>
            <Flex my={2}>
              <Iconly label={"time"} name="TimeCircle" set="bold" primaryColor="black" size="small" />
              <Text fontSize={"xs"} ml={2}> {courses.lecture_hours} </Text>
            </Flex>
            <Flex my={2}>
              <Iconly label={"day"} name="ShieldDone" set="bold" primaryColor="black" size="small" />
              <Text fontSize={"xs"} ml={2}> {courses.lecture_days} </Text>
            </Flex>
            <Box textAlign={"center"}>
              <Button size={"md"} width={"100px"} bgColor={"red.500"} fontSize={"sm"}>Unregister</Button>
            </Box>
          </Flex>
        ))}
      </Grid>
    </Flex>
  );
}

export default StudentCourses;